import { Component, Inject, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NewCardComponent } from "../new-card/new-card.component";
import { ApsService } from "../../../services";
import { CreditCardInfo, AddAPSRequestOfCreditCardInfo, APSMaster } from "../../../models";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ErrorDialogComponent } from "../../../components/error-dialog/error-dialog.component";
import { SpinnerService } from "../../../services/spinner.service";
import { ProcessingDialogComponent } from "../../../components/processing-dialog/processing-dialog.component";
import { FormValidationService } from "src/app/services/form-validation.service";
import { AbstractControl, Form } from "@angular/forms";

@Component({
    selector: "app-new-card-dialog",
    templateUrl: "./new-card-dialog.component.html",
    styleUrls: ["./new-card-dialog.component.scss"],
})
export class NewCardDialogComponent
{
    card: APSMaster;
    cardInfo: CreditCardInfo;
    isSubmitted: boolean = false;
    addAPSRequestCredit: AddAPSRequestOfCreditCardInfo;

    @ViewChild(NewCardComponent) newCardElement: NewCardComponent;

    constructor(
        public dialogRef: MatDialogRef<NewCardDialogComponent>,
        private apsService: ApsService,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        private formValidationService: FormValidationService,
        private spinnerService: SpinnerService,
        @Inject(MAT_DIALOG_DATA) public data: APSMaster,
    )
    {
        this.card = { ...data };
    }

    public handleSubmit(): void
    {

        this.isSubmitted = true;
        const dialogText: string = "Credit Card";

        const dialogRefProcessing = this.dialog.open(ProcessingDialogComponent, {
            data: dialogText,
            width: "400px",
            maxWidth: "90%",
            restoreFocus: false,
            disableClose: true,
        });

        this.cardInfo = this.newCardElement.getCardInfo();

        this.apsService.addCreditCard(this.cardInfo).subscribe(b => 
        {
            if (b.valueOf()) 
            {
                this.dialog.closeAll();
            }
            else
            {
                this.errorDialog("")
                dialogRefProcessing.close();
            }
        },
            (error) =>
            {
                dialogRefProcessing.close();
                this.errorDialog(error);
            });
        this.spinnerService.hide();
    }
    public checkFormValidity(form): void
    {
        form?.markAllAsTouched?.();

        if (!this.formValidationService.checkFormValidity(form)) 
        {
            return;
        }
        this.handleSubmit();
    }


    errorDialog(error): void
    {
        this.isSubmitted = false;
        const errorMessage: string = "An error occurred while adding a card. \n   " + error;

        this.dialog.open(ErrorDialogComponent, {
            minWidth: "360px",
            data: errorMessage,
        });

    }
}
